export enum Permissions {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MANAGER = 'manager',
  MECHANIC = 'mechanic',
}